import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import "./sass/index.scss";
import "./sass/firebase/firebaseui-styling.global.scss";
import App from "./app/App";
import reduxStore from "./app/reduxStore/store";
import reportWebVitals from "./reportWebVitals";
import StoreProvider from "./app/store/StoreProvider";
import { isElectronApp } from "./app/common/utils/electronAppHelper";

let Router;

// 若是桌面應用, 則需要使用 HasRouter, 才可以正確載入 首頁,image 等靜態檔案
if (isElectronApp()) {
  Router = HashRouter;
} else {
  Router = BrowserRouter;
}

ReactDOM.render(
  <React.StrictMode>
    {/* 在最上層提供 global store */}
    <StoreProvider>
      <Provider store={reduxStore}>
        <Router>
          <App />
        </Router>
      </Provider>
    </StoreProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
